import styled from 'styled-components';

interface IContainerProps {
  $isDragging: boolean;
}

export const Container = styled.div<IContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  z-index: -1;

  ${({ $isDragging }) =>
    $isDragging &&
    `
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999999999;

    > ${WrapperInfo} {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `}
`;

/** STYLES TO DRAGDROPAREA.TSX * */

export const TitleDragDrop = styled.h4``;
export const TextDragDrop = styled.p``;

export const WrapperInfo = styled.div`
  display: none;
  pointer-events: none;
  user-select: none;

  > h4,
  > p,
  > svg {
    font-size: 4rem;
  }

  > svg,
  > h4 {
    color: ${({ theme }) => theme.pantone2726C};
  }
`;
export const ContainerArea = styled.div<IContainerProps>`
  border: ${({ theme }) => `2px dashed ${theme.pantone2726C}`};
  background: ${({ $isDragging, theme }) =>
    $isDragging ? theme.pantone642C : theme.white};
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  transition: all 0.2s;
  cursor: pointer;
  > p {
    margin: 0;
  }

  &:hover {
    background: ${({ theme }) => theme.pantone642C};
  }
`;

